'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modals = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _modals = require('constants/modals');

var MODALS = _interopRequireWildcard(_modals);

var _connectModal = require('./connectModal');

var _connectModal2 = _interopRequireDefault(_connectModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modals = exports.Modals = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Modals, _Component);

  function Modals() {
    (0, _classCallCheck3.default)(this, Modals);
    return (0, _possibleConstructorReturn3.default)(this, (Modals.__proto__ || (0, _getPrototypeOf2.default)(Modals)).apply(this, arguments));
  }

  (0, _createClass3.default)(Modals, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      // Only will re-render if the number of modals changes.
      // The changes of the modals will be handled by "connectModal".
      return (0, _keys2.default)(this.props.modals).length !== (0, _keys2.default)(nextProps.modals).length;
    }
  }, {
    key: '_getModalClass',
    value: function _getModalClass(modal) {
      switch (modal) {
        case MODALS.CONFIRM:
          return _components.EnterpriseConfirm;

        case MODALS.LOGIN:
          return _components.EnterpriseModal;

        case MODALS.RULES:
          return _components.EnterpriseRules;

        case MODALS.DEFAULT:
        default:
          return _components.EnterpriseModal;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var modals = this.props.modals;

      var modalKeys = (0, _keys2.default)(modals);

      // Map all the modals into connected Components
      var modalsComponents = modalKeys.map(function (modalKey) {
        var ModalClass = _this2._getModalClass(modalKey);
        var Modal = (0, _connectModal2.default)(ModalClass, modalKey);

        return _react2.default.createElement(Modal, { key: 'tq-plus-admin-modal-' + modalKey });
      });
      return _react2.default.createElement(
        'div',
        null,
        modalsComponents
      );
    }
  }]);
  return Modals;
}(_react.Component), _class.propTypes = {
  modals: _react.PropTypes.object
}, _class.defaultProps = {
  modals: {}
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  return { modals: state.modals };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Modals);


//////////////////
// WEBPACK FOOTER
// ./src/containers/Modals/Modals.jsx
// module id = 1636
// module chunks = 0